import * as React from "react";
import { Collapse, makeStyles } from "@material-ui/core";
import useLocalStorage from "../../hooks/useLocalStorage";
import PromotionBannerCloseIcon from "../Icons/promotionBannerClose";

export interface PromotionBannerProps {
  name: string;
  useLocalStorage?: boolean;
  useDateCheck?: boolean;
  href?: string;
  closeable?: boolean;
  onClick?: () => void;
  onClose?: () => void;
}

interface datedValue {
  value: boolean;
  date: string;
}

const propsDefaults = {
  useLocalStorage: true,
  useDateCheck: false,
  closeable: true,
}

export const PromotionBanner: React.FC<PromotionBannerProps> = (props) => {
  props = {...propsDefaults, ...props};

  const initialValue = props.useDateCheck ? {value: true, date: new Date().toISOString().slice(0, 10)} : true;
  const [showPromotionBanner, setShowPromotionBanner] = props.useLocalStorage ? useLocalStorage(props.name, initialValue) : React.useState(true);

  const classes = useStyles({...props});

  const handleClick = () => {
    props.onClick && props.onClick();
  }

  const handleClose = (event: React.MouseEvent<SVGElement>) => {
    event.preventDefault();

    props.onClose && props.onClose();
    setShowPromotionBanner(props.useDateCheck ? {value: false, date: new Date().toISOString().slice(0, 10)} : false);
  }

  return (
    <Collapse in={props.useDateCheck ? (showPromotionBanner as datedValue).value || (showPromotionBanner as datedValue).date !== new Date().toISOString().slice(0, 10) : showPromotionBanner as boolean}>
      <a 
        className={classes.root}
        target="_blank"
        rel="noopener noreferrer"
        href={props.href}
      >
        <picture onClick={handleClick}>
          {props.children}
        </picture>
        {props.closeable && <PromotionBannerCloseIcon className={classes.close} onClick={handleClose} />}
      </a>
  </Collapse>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "block",

    position: "relative",

    width: "100%",

    border: "1px solid transparent",
    borderRadius: 4,
    cursor: (props: PromotionBannerProps) => props.href ? "pointer" : "normal",

    "& img": {
      width: "100%",
      height: "100%",

      objectFit: "cover",
    }
  },
  close: {
    position: "absolute",
    top: 7,
    right: 7,

    borderRadius: 10,
    color: "#8d8d8d",

    "&:hover": {
      color: "#ffffff",
    }
  },
}));
